import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { createChapter } from '../../actions';

class NewChapter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: '',
      errorMsg: '',
    };
  }

  newChapter = () => {
    if (this.state.title) {
      this.props.createChapter(this.props.currentBook.id, this.state, this.props.history);
    } else {
      this.setState({ errorMsg: 'Chapter title cannot be blank' });
    }
  }

  handleInputChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  renderChapterCreation = () => {
    return (
      <div className="new-chapter-item">
        <input type="text"
          onChange={this.handleInputChange}
          value={this.state.title}
          name="title"
          placeholder="chapter title"
        />
      </div>
    );
  }

  render() {
    return (
      <div id="new-chapter">
        <h2 className="new-chapter-item">
          Start a New Chapter in <span id="new-chapter-book-name">{this.props?.currentBook?.title}</span>
        </h2>
        <p>By starting a new chapter in this book, you are creating a new topic around which the community can share and discover stories.</p>
        {this.renderChapterCreation()}
        <button variant="contained" type="submit" id="submit" onClick={this.newChapter}>Create</button>
        <p>{this.state.errorMsg}</p>
      </div>
    );
  }
}
const mapStateToProps = (state) => (
  {
    currentBook: state.books.current,
  }
);

export default withRouter(connect(mapStateToProps, { createChapter })(NewChapter));
